module.exports = __webpack_public_path__ + "img/logo.9fd1527d.svg";